export class WorkspaceSet {
  public id: string;

  constructor(id: string) {
    this.id = id;
  }
}
